<div class="d-flex">
  <div class="d-flex flex-row">
    <button type="button"
      class="btn btn-outline-primary d-flex flex-row align-items-center justify-content-center morefilters"
      (click)="isCollapsed.set(!isCollapsed())" [disabled]="!objetAC?.results" [attr.aria-expanded]="!isCollapsed()"
      aria-controls="collapseExample"><mat-icon>{{statusMoreFilters()}}</mat-icon>{{'filters' | translate}}</button>
    <div class="ngcollapse" #collapse="ngbCollapse" [horizontal]="true" [ngbCollapse]="!isCollapsed()">
      @if(objetAC?.results){
      <div class="d-flex bodycollapse justify-content-around">
        <div class="d-flex flex-column align-items-center">
          <mat-form-field class="form-field" appearance="outline">
            <input matInput type="text" [formControl]="searchmodel"
              placeholder="{{'component-searchbar-research' | translate}}">
            @if (searchmodel.value) {
            <button matSuffix matIconButton aria-label="Clear" (click)="searchmodel.setValue('')">
              <mat-icon>close</mat-icon>
            </button>
            }
          </mat-form-field>
          <div class="matchips">
            <mat-chip-listbox class="d-flex flex-row align-items-center" aria-label="id-selection">
              @for(cat of getLKeysSearch(); track cat) {
              <mat-chip-option (selectionChange)="changeSelected($event, cat)">{{cat}}</mat-chip-option>
              }
            </mat-chip-listbox>
          </div>
          @if(!checkSearch()) {
          <p class="alert-search">{{'filters-search-error' | translate}}</p>
          }
        </div>
        <!-- Application Dropdown -->
        <div ngbDropdown #Application="ngbDropdown">
          <button type="button" class="btn d-flex align-items-center" id="application" ngbDropdownAnchor
            (focus)="Application.open()">
            <p>{{selectedApp()}}</p>
          </button>
          <div ngbDropdownMenu aria-labelledby="application">
            <button ngbDropdownItem #None value="None" (click)="resetApp();">{{'none' | translate}}</button>
            @for(app of getAllAppNames(); track app) {
            <div [formGroup]="formApplication">
              <mat-checkbox class="text-capitalize d-flex align-self-center" (change)="initVappForm(app)"
                [indeterminate]="someCompleteApp(app)" formControlName="{{app}}">
                @if(app.length > 15) {
                <p type="button" placement="right" [ngbTooltip]="app">{{formatLongString(app,15)}}</p>
                } @else {
                <p>{{app}}</p>
                }
              </mat-checkbox>
            </div>
            }
            @for(app of getAllAppNames(); track app) {
            @if(formApplication.value[app] && getAllVersionForApp(app).length > 0) {
            <div class="dropdown-divider"></div>
            <div class="sectionoshead">
              <h5>{{'filters-versions-of' | translate}} {{formatLongString(app,25)}}</h5>
            </div>

            @for(v of getAllVersionForApp(app); track v) {
            <div [formGroup]="formVersionApplication">
              <div [formGroupName]="app">
                <mat-checkbox (change)="checkIfnoVforApp(app)" formControlName="{{v}}"
                  class="text-capitalize d-flex align-self-center">
                  @if(v.length > 15) {
                  <p class="version" type="button" placement="right" [ngbTooltip]="v">{{formatVersionFiltre(v)}}</p>
                  } @else {
                  <p class="version">{{v}}</p>
                  }
                </mat-checkbox>
              </div>
            </div>
            }
            }
            }
          </div>
        </div>
        <!-- BW Dropdown -->
        <div ngbDropdown #BW="ngbDropdown">
          <button type="button" class="btn d-flex align-items-center" id="bw" ngbDropdownAnchor (focus)="BW.open()">
            <img src="assets/icons/probesFamilies/black&White.png">
            <p>{{selectedBWV()}}</p>
          </button>
          <div [formGroup]="formBW" ngbDropdownMenu aria-labelledby="bw">
            <button ngbDropdownItem #None value="None" (click)="resetFormBWV()">{{'none' | translate}}</button>
            @for(bwv of getVBW(); track bwv) {
            <mat-checkbox class="text-capitalize d-flex align-self-center" formControlName="{{bwv}}">
              <p type="button" placement="right" [ngbTooltip]="bwv">{{formatLongString(bwv,17)}}</p>
            </mat-checkbox>
            }
          </div>
        </div>
        <!-- OS Dropdown -->
        <div ngbDropdown #OS="ngbDropdown">
          <button type="button" class="btn d-flex align-items-center" id="os" ngbDropdownAnchor (focus)="OS.open()">
            @if(selectedOS()!='OS' && selectedOS()!='icons') {
            <img src="assets/icons/logosOS/{{selectedOS().toLowerCase()}}.svg">
            }
            @if(selectedOS()!='icons') {
            <p class="text-capitalize">{{selectedOS()}}</p>
            }
            @if(selectedOS()!='OS' && selectedOS()=='icons') {
            <div class="d-flex flex-row">
              @for(osselec of losactif(); track osselec) {
              <img src="assets/icons/logosOS/{{osselec.toLowerCase()}}.svg">
              }
            </div>
            }
          </button>
          <div ngbDropdownMenu aria-labelledby="os">
            <button ngbDropdownItem #None value="None" (click)="selectOS(None.value); resetOSFiltre()">{{'none' | translate}}</button>
            @for(os of getAllOs(); track os) {
            <div [formGroup]="formOS">
              <mat-checkbox (change)="selectOS(os);InitFormVOS(getAllVofOs(os),os)" [indeterminate]="someCompleteOS(os)"
                class="text-capitalize d-flex align-self-center" formControlName="{{os.toLowerCase()}}">
                <img src="assets/icons/logosOS/{{os.toLowerCase()}}.svg">{{os}}
              </mat-checkbox>
            </div>
      
            @if(formOS.value[os.toLowerCase()] == true && getAllVofOs(os).length > 0) {
            <div class="dropdown-divider"></div>
            <div class="d-flex flex-row align-items-center sectionoshead">
              <h5>{{'filters-versions-os' | translate}}</h5>
              <img class="imgsectionvceck" src="assets/icons/logosOS/{{os.toLowerCase()}}.svg">
            </div>
            @for(v of getAllVofOs(os); track v) {
              <div [formGroup]="formVOS">
                <div [formGroupName]="os.toLowerCase()">
                  <mat-checkbox (change)="checkIfnoVforOS(os)" formControlName="{{v}}"
                    class="text-capitalize d-flex align-self-center">
                    <p class="version">{{v}}</p>
                  </mat-checkbox>
                </div>
              </div>
              }
            }
            }
          </div>
        </div>
        <!-- DeviceModel Dropdown -->
        <div ngbDropdown #DeviceModel="ngbDropdown">
          <button type="button" class="btn d-flex align-items-center" id="device-model" ngbDropdownAnchor
            (focus)="DeviceModel.open()">{{selectedModele()}}</button>
          <div [formGroup]="formModel" ngbDropdownMenu aria-labelledby="device-model">
            <button ngbDropdownItem #None value="None" (click)="resetModelForm()">{{'none' | translate}}</button>
            @for(device of getAllDevices(); track device) {
            @if(device && device != '') {
            <mat-checkbox class="text-capitalize d-flex align-self-center" formControlName="{{device}}">
              <p>{{device}}</p>
            </mat-checkbox>
            }
            }
          </div>
        </div>
        <button type="button" [disabled]="!checkSearch()" (click)="applyFilters()"
          class="search btn btn-outline-success"><mat-icon>search</mat-icon></button>
      </div>
      }
    </div>
  </div>
</div>